import {getViewportGeometry} from "../src/viewport-geometry";
import {elementsGeometry} from "../src/elements-geometry";
import {throttle} from "../src/throttle";

const $ = jQuery;

const sticky = () => $('.ntz-gutenberg-toc');

const items = () => sticky().find('.ntz-gutenberg-toc--item, .gutenberg-toc-after');
const anchors = () => items().find('a').map((i, item) => $($(item).attr('href')));

let previousScrollPosition = $(window).scrollTop();

const scrollDirectionIsForward = () => {
    const scrollTop = $(window).scrollTop();
    const isForward = previousScrollPosition < scrollTop;

    previousScrollPosition = scrollTop;

    return isForward;
}


const highlightTocMenu = (id) => {
    const activeClass = 'toc-is-active';

    if (!id) {
        items().removeClass(activeClass);
    }

    const activeMenuItem = items().filter((i, item) => $(item).find('a').attr('href') === `#${id}`);

    activeMenuItem.addClass(activeClass).siblings().removeClass(activeClass);
}

function maybeActivateMenu() {
    const viewportGeometry = getViewportGeometry()
    const elements = elementsGeometry(anchors(), viewportGeometry);

    const visible = elements.findLast((geometry) => geometry.viewport.scrollTopFistQuarter >= geometry.position.top);

    highlightTocMenu(visible?.el.attr('id'));
}

const maybeActivateMenuRAF = () => throttle(requestAnimationFrame(maybeActivateMenu));

$(window).on('resize.ntz-highlight-toc', maybeActivateMenuRAF);
$(window).on('scroll.ntz-highlight-toc', maybeActivateMenuRAF);
$(window).on('ntz-image-loaded', maybeActivateMenuRAF);

maybeActivateMenu();